import styled from 'styled-components';
import { Text12Light } from '../../utils/Text/Text.styles';

export const Card = styled.div`
  height: 13rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 1.4rem;
  position: relative;
`;

export const GrossValue = styled(Text12Light)`
  opacity: 0.5;
  margin-top: 0.2rem;
`;

export const HiddenGrossValue = styled(GrossValue)`
  opacity: 0;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const ValueTextContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.4rem;
`;
